function loadImage(src: string): Promise<void> {
  return new Promise((resolve) => {
    const image = new Image()
    const timeout = window.setTimeout(resolve, 8_000)
    const finish = () => {
      window.clearTimeout(timeout)
      resolve()
    }
    image.onload = finish
    image.onerror = finish
    image.src = src
  })
}

export async function preloadSlides(urls: string[], eagerCount = 2): Promise<void> {
  const valid = urls.filter(Boolean).slice(0, 30)
  const eager = valid.slice(0, eagerCount)
  const rest = valid.slice(eagerCount)
  rest.forEach((src) => {
    const image = new Image()
    image.src = src
  })
  await Promise.all(eager.map(loadImage))
}
